import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class SyncronizationService {

    EventReloadContent = new EventEmitter();

}